import seedrandom from 'seedrandom';
import { type CssRngFn, makeCssRng } from './css';
import {
    makeUniformRng,
    mapRngFunction,
    type RngFn,
    type UniformRng,
} from './distributions';

export function createBaseRng(...args: unknown[]) {
    if (args.length === 0) return seedrandom.alea();
    return seedrandom.alea(String(args));
}

export interface Rng extends seedrandom.PRNG, RngFn {
    double: RngFn;
    quick: RngFn;
    uniform: UniformRng;
    css: CssRngFn;
}

export function createRng(...args: unknown[]): Rng {
    const base = createBaseRng(...args);
    const result = mapRngFunction(base);

    return Object.assign(result, {
        double: mapRngFunction(base.double),
        quick: mapRngFunction(base.quick),
        int32: base.int32,
        // state: base.state,
        uniform: makeUniformRng(base),
        css: makeCssRng(base),
    });
}

export function* rng(...args: unknown[]): Generator<number, number> {
    const rng = createBaseRng(...args);
    while (true) {
        yield rng.quick();
    }
}
